module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('img', {
    attrs: {
      "src": "images/aranysav.jpg",
      "width": "100%",
      "alt": ""
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "new_footer_top_area",
    staticStyle: {
      "background": "#301e1c"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "my_widget_conts"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "widget_below_box"
  }, [_c('div', {
    staticClass: "widget_form_box",
    staticStyle: {
      "margin": "0 80px 0 70px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control footer-input",
    attrs: {
      "type": "name",
      "placeholder": "Név",
      "name": "firstname",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control footer-input",
    attrs: {
      "type": "name",
      "placeholder": "Email",
      "name": "firstname",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-control footer-input",
    attrs: {
      "placeholder": "Üzenet írása...",
      "name": "message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "my-button",
    staticStyle: {
      "background-image": "url('images/aranysav.jpg')"
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("Küldés")])])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my_widget_box"
  }, [_c('div', {
    staticClass: "my_widget"
  }, [_c('img', {
    attrs: {
      "src": "images/env.png",
      "width": "60",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px",
      "font-size": "16pt"
    }
  }, [_vm._v("info@panoramabekescsaba.hu")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "my_widget_conts"
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px",
      "color": "#F1EBC7"
    }
  }, [_vm._v("TÉRKÉP")]), _vm._v(" "), _c('div', {
    staticClass: "widget_below_box"
  }, [_c('div', {
    staticClass: "map_box"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2737.4696593279227!2d21.130413815598505!3d46.67673077913394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47442b0c47278f7b%3A0xbfbd1c8b3f70f949!2sPanor%C3%A1ma+Hotel!5e0!3m2!1shu!2shu!4v1544196393394",
      "width": "200",
      "height": "130",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "my_widget_conts"
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px",
      "color": "#F1EBC7"
    }
  }, [_vm._v("KAPCSOLAT")]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('img', {
    attrs: {
      "src": "images/iphone.png",
      "alt": ""
    }
  }), _c('span', [_vm._v("+ 36 66 547-770")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "images/imobile.png",
      "alt": ""
    }
  }), _c('span', [_vm._v("+ 36 30/ 278 35 32")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@panoramabekescsaba.hu"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/iemail.png",
      "alt": ""
    }
  }), _c('span', [_vm._v("info@panoramabekescsaba.hu")]), _c('br')]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "images/iplace.png",
      "alt": ""
    }
  }), _c('span', [_vm._v("5600 Békéscsaba, Gyulai út 84.")]), _c('br')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "new_last_footer",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "new_copy_text text-center"
  }, [_c('p', [_vm._v("Panoráma Wellness Kft. Copyright     -      Minden jog fenntartva.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66fc642f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/bora/Footer.vue
// module id = 117
// module chunks = 0 1 2